import {Button, Grid, TextField} from "@mui/material";
import {useState} from "react";
import {API} from "../framework/api";
import {TXT_SUBTITLE} from "../framework/constants";
import {confirmAlert} from "react-confirm-alert";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";

export function AssignmentPage(props) {
  const [assignmentText, setAssignmentText] = useState('');

  const handleAddAssignment = () => {
    API.getAPI().add_assignment(assignmentText).then((response)=> {
      confirmAlert({
        title: "Uppdraget lämnat",
        message: "Tack för informationen! Vi återkommer så snart som möjligt!",
        buttons: [{
          label: "Avfärda",
          onClick: () => { window.location.hash="#/anslagstavlan"; }
        }]
      });
    }).catch((e) => {
      confirmAlert({
        title: "Uppdrag kunde inte lämnas",
        message: "Tyvärr kunde inte uppdraget lämnas. Vänligen försök igen om en liten stund.",
        buttons: [{
          label: "Avfärda",
        }]
      });
      console.error(e);
    });
  }

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Välkommen till anslagstavlan</div>
      <div className={"App-subTitle"}>{TXT_SUBTITLE}</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={12} md={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={12} md={9} className={"App-container-rightContent"}>
          <div className={"App-rightContent"}>
            <Grid container={true} spacing={0}>

              {/*** App Right content ***/}

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Fyll i ditt önskeuppdrag</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                <TextField
                  multiline={true}
                  minRows={10}
                  placeholder="Jag vill arbeta med..."
                  style={{ minWidth: '100%' }}
                  value={assignmentText}
                  onChange={(e)=> setAssignmentText(e.target.value)}
                />

              </Grid>
              <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

                <Button
                  className={"App-button-contained"}
                  variant={"contained"}
                  onClick={handleAddAssignment}
                >
                  Lämna uppdrag
                </Button>
              </Grid>

            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
